import { schemas } from '@/data/form-schema.ts'

export const DataSchemaService = {
  async getApplicationSchema(locale: string, alias: string) {
    return {
      data: JSON.parse(JSON.stringify(schemas[locale]?.find((schema: any) => schema.alias === alias)))
    }
  }
}
